module.exports = __webpack_public_path__ + "static/media/google-play.deb3d9a1.png";